var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"image-container",class:{inline: _vm.inline},style:({'width': _vm.width, 'height': _vm.height}),attrs:{"href":_vm.src,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }